// removed by extract-text-webpack-plugin
module.exports = {"arrow":"ExpressView__arrow","down-arrow":"ExpressView__down-arrow","downArrow":"ExpressView__down-arrow","up-arrow":"ExpressView__up-arrow","upArrow":"ExpressView__up-arrow","expview-container":"ExpressView__expview-container","expviewContainer":"ExpressView__expview-container","seedetails-link":"ExpressView__seedetails-link","seedetailsLink":"ExpressView__seedetails-link","seedetails-link-b":"ExpressView__seedetails-link-b","seedetailsLinkB":"ExpressView__seedetails-link-b"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/ExpressView.scss
// module id = 772
// module chunks = 8